import React, { useState } from 'react'

import useDebounce from './useDebounce'

const useSearch = () => {
	const debounce = useDebounce<string>()
	const [searchText, setSearchText] = useState('')
	const [debouncedSearchText, setDebouncedSearchText] = useState('')

	const handleSearchChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		const { value } = e.target

		setSearchText(value)
		debounce(value, (debouncedValue) => {
			setDebouncedSearchText(debouncedValue)
		})
	}

	const handleClearSearchClick = () => {
		setSearchText('')
		setDebouncedSearchText('')
	}

	return {
		searchText,
		debouncedSearchText,
		handleSearchChange,
		handleClearSearchClick,
	}
}

export default useSearch
